module.exports = __webpack_public_path__ + "78278990fff100832ea12ad344a09411.pdf";